const WELCOME_SEEN_KEY = "guardians_welcome_seen_v1"

export function isWelcomeSeen(): boolean {
  try {
    return localStorage.getItem(WELCOME_SEEN_KEY) === "1"
  } catch {
    return false
  }
}

export function markWelcomeSeen(): void {
  try {
    localStorage.setItem(WELCOME_SEEN_KEY, "1")
  } catch {
    // ignore
  }
}

export function clearWelcomeSeen(): void {
  try {
    localStorage.removeItem(WELCOME_SEEN_KEY)
  } catch {
    // ignore
  }
}
